import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SessionHandlerService } from '../services/sessionHandler.service';
import { AppIdleService } from '../services/app-idle.service';
import { CommonConstants } from '../utilities/commonConstants';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

  constructor(private _appIdleService: AppIdleService, private _sessionHandler: SessionHandlerService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap(() => {
        const applicationId = this._sessionHandler.GetSession(CommonConstants.CookieKeys.LoanApplicationId);
        if (applicationId) {
          this._appIdleService.resetTimer();
        }
      })
    );
  }
}
